import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import Home from "@/pages/home";
import NotFound from "@/pages/NotFound";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import Founder from "@/pages/founder";
import About from "@/pages/about";
import Blog from "@/pages/blog";
import BlogPost from "@/pages/blog-post";
import { SEO } from "@/components/SEO";
import { ChittaraScrollBackground } from "@/components/ChittaraScrollBackground";


function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/founder" component={Founder} />
      <Route path="/about" component={About} />
      <Route path="/blog" component={Blog} />
      <Route path="/blog/:slug" component={BlogPost} />
      <Route path="/privacy-policy" component={PrivacyPolicy} />
      <Route path="/terms-of-use" component={TermsOfUse} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <SEO
          title="Ganji Drinks — Freedom in Our Soil. Tradition in Every Sip."
          description="Freedom in our soil. Tradition in every sip. Explore India's Independence Day story and discover Ganji — traditional ready-to-drink ragi energy beverage."
          image="https://ganjidrinks.shop/images/independence-social-preview.jpg"
        />
        
        <ChittaraScrollBackground />
        <Router />
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
